const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '全网吃瓜内容实时追踪，第一时间推送台北娜娜、玩偶姐姐等网红最新动态，快人一步不错过任何名场面。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '轻量版体验',
    desc: '51吃瓜轻量版吃瓜短视频，流畅播放不卡顿，省流量设计让你随时随地畅享吃瓜娱乐现场的精彩内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '内容甄选',
    desc: '严格筛选每一条吃瓜短视频，确保搞笑吃瓜瞬间和吃瓜真人秀片段质量上乘，拒绝低质搬运。',
  },
  {
    icon: 'ri-group-line',
    title: '吃瓜社区',
    desc: '汇聚千万吃瓜爱好者，一起讨论网红直播翻车名场面，分享你的吃瓜观点和独家爆料。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          为什么千万用户选择51吃瓜爆料网
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/80 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${f.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}